import {styled} from '@mui/material/styles'


export const LongText = styled("span")(() => ({
    display: "inline-flex",
    alignItems: "center",
    width: "100%",
    minWidth: 0,
    whiteSpace: "nowrap",
}))